import { HStack } from '@web/components/atoms/Layout'
import { Switch } from '@web/components/atoms/Switch'
import { ReactNode } from 'react'

type PageSwitchProps = {
  id: string
  isChecked: boolean
  onChange: (value: boolean) => void
  label: string | ReactNode
  name?: string
}

const PageSwitch = ({ id, name, onChange, label, isChecked }: PageSwitchProps) => {
  return (
    <HStack onClick={() => onChange(!isChecked)} cursor="pointer">
      <Switch
        id={id}
        name={name}
        checked={isChecked}
        justifyContent="space-between"
        flexDirection="row-reverse"
        w="100%"
        css={{
          '&': {
            pointerEvents: 'none',
            '--chakra-colors-color-palette-solid': 'var(--branding-button-primary-bg-color)',
            '--chakra-colors-border': 'ge.input.outline',
          },
          '& .chakra-switch__control[data-checked]': {
            bgColor: 'var(--branding-button-primary-bg-color)',
            borderColor: 'var(--branding-button-primary-bg-color)',
          },
          '& .chakra-switch__label': {
            whiteSpace: 'pre-line',
          },
        }}
      >
        {label}
      </Switch>
    </HStack>
  )
}

export default PageSwitch
